export class WsiErrorExt {
  public constructor(public wsiError: WsiError | string) {
  }

  public toString(): string {
    if (this.wsiError instanceof WsiError) {
      return `wsiError: ${this.wsiError.error}; wsiErrorId: ${this.wsiError.id};
              wsiErrorDetails: ${this.wsiError.details}; status: ${this.wsiError.status}; statusText: ${this.wsiError.statusText}`;
    }
    else {
      return this.wsiError;
    }
  }

  public message(): string {
    if (this.wsiError instanceof WsiError) {
      return this.composeMessage(this.wsiError);
    }
    else {
      return this.wsiError;
    }
  }

  private composeMessage(error: WsiError): string {
    if (error.status === 0) {
      return `No connection to the building management system could be established.
              Check that the URL is correct and the web server and the system is running.`;
    }
    else if (error.id === 2400000) {
      return "The entered user name or password is incorrect.";
    }
    else if (error.details != undefined) {
      return error.details;
    }
    else {
      return "Failed to call the building management system.";
    }
  }
}

export class WsiError {

  public constructor(public status: number, public statusText: string, public error: string, public id: number, public details: string) {
  }

  public get ok(): boolean {
    return ((this.status >= 200) && (this.status < 300)) ? true : false;
  }
}
